import React, {useCallback, useState, useEffect} from 'react';
import { connect } from "react-redux";
import EffectMods from 'components/effects/EffectMods.js';
import {setSelectedRackSubTrack} from 'actions/index.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import TrackSlot from './TrackSlot.js';
import '../../InstrumentRack.scss';
import {getEffectsComponent} from 'components/effects/getEffectsComponent.js';
import DropInstrumentHere from './DropInstrumentHere.js';
import {getInstrumentComponent} from 'components/effects/getInstrumentComponent.js';
import MultiParameterSlider from './sampledInstrument/MultiParameterSlider.js';

function InstrumentRackComponent(props) {
    let {track, selectedInstrument, setSelectedInstrument, scrollContainer} = props;
    const [tracks, setTracks] = useState(track.tracks);
    const [showMods, setShowMods] = useState(false);
    const newInstrument = useCallback((type) => {
        let t = track.addInstrumentType(type);
        setTracks([... track.tracks]);
        setSelectedInstrument(t);
    }, [track, setTracks, setSelectedInstrument]);

    useEffect(() => {
        setTracks(track.tracks);
    }, [track.tracks, setTracks]);

    const newPreset = useCallback(async (preset) => {
        let t = await track.addPreset(preset);
        setTracks([... track.tracks]);
        setSelectedInstrument(t);
    }, [track, setTracks, setSelectedInstrument]);

    const newSample = useCallback(async (sample, samplesStream) => {
        let t = await track.addSample(sample, samplesStream);
        setTracks([... track.tracks]);
        setSelectedInstrument(t);
    }, [track, setTracks, setSelectedInstrument]);


    const deleteInstrument = useCallback(() => {
        track.deleteInstrument(selectedInstrument);
        setSelectedInstrument(undefined);
        setTracks([... track.tracks]);
    }, [track, setTracks, setSelectedInstrument, selectedInstrument]);

    let effect = track.tracks.indexOf(selectedInstrument) > -1 ?
        getEffectsComponent(selectedInstrument.track, scrollContainer, true) :
        '';

    const onDuplicate = useCallback(async (t) => {
        let duplicatedTrack = await t.getCopy();
        track.addInstrument(duplicatedTrack);
        setSelectedInstrument(undefined);
        setTracks([... track.tracks]);
    }, [setTracks]);

    /*
    let slider = track.tracks.indexOf(selectedInstrument) > -1 ?
        getMultiParameterSlider(selectedInstrument, onDuplicate, setShowMods, showMods) :
        '';
        */


    let controllerClass = "instrument-rack-controller";
    if (showMods) {
        controllerClass += " show-mods";
    }
    return (
        <div className="instrument instrument-rack">
          <div className={controllerClass}>
            {tracks.map(
                instrument =>
                    <TrackSlot
                          name={instrument.presetName || instrument.getName()}
                          key={instrument.presetName || instrument.getName()}
                          rackTrack={track}
                          isSelected={selectedInstrument === instrument}
                          onDelete={() => deleteInstrument()}
                          onSelect={() => setSelectedInstrument(instrument === selectedInstrument ? undefined : instrument)}
                          track={instrument}
                      />)}
            {showMods && selectedInstrument ? 
              <EffectMods
                parameters={selectedInstrument.getAllParameters()}
                setShowMods={setShowMods}
                showMods={showMods}/>
                : ''}
            <DropInstrumentHere
              newInstrument={newInstrument}
              newPreset={newPreset}
              newSample={newSample}
              track={track}/>
          </div>
            {effect}
        </div>
    );
};

function getMultiParameterSlider(track, onDuplicate, setShowMods, showMods) {
    let {sequencerEngine} = track.track;
    let modsClass = showMods ? 'toolbar-button selected' : 'toolbar-button';

    return (
        <div>
          <MultiParameterSlider
            showMods={showMods}
            sequencerEngine={sequencerEngine}
            parameters={{
                "Vol": {
                    parameter: track.volumeParameter,
                    min: -40,
                    max: 0
                },
            }}/>
          <div className="toolbar">
            <div
              onClick={() => onDuplicate(track)}
              className="toolbar-button">
              Duplicate
            </div>
            <div
              onClick={() => setShowMods(!showMods)}
              className={modsClass}>
              Mods
            </div>
          </div>
        </div>
    );
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        setSelectedInstrument: (track) => dispatch(setSelectedRackSubTrack(props.track.id, track)),
    };
};

const mapStateToProps = (state, props) => {
    return {
        selectedInstrument: state.tracks.selectedRackSubTrack[props.track.id],
        tracks: props.track.tracks
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(InstrumentRackComponent);
